<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">General Partner
               <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
              <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-12">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="investor-list" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9">
                                    <h4 class="card-title">Investor List</h4>

                                      <div class="table-responsive" v-if="investors.length">
                                        <div class="pta-investor-selection" style="font-size:24px;">
                                        <table class="table table-hover" style="max-width:100%;">
                                          <thead>
                                          <tr>
                                            <th>Organisation</th>
                                            <th>Investor&nbsp;Type</th>
                                            <th>Preferred Asset Class</th>
                                            <th>Preferred Geographic Area</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="investor in investors" v-if="investors && investor.name" :class="investor.pivot.is_deactive==2?'pta-investor-deactivated':''">
                                            <td valign="top" v-html="investor.name"></td>
                                            <td valign="top">
                                              <span v-for="investor_type in investor.investor_types">{{investor_type}}</span>
                                            </td>
                                            <td valign="top">
                                              <span v-for="asset_class in investor.asset_classes">{{asset_class}}</span>
                                            </td>
                                            <td valign="top">
                                              <span v-for="geo in investor.geos">{{geo}}</span>
                                            </td>
                                          </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import vSelect from 'vue-multiselect'

    export default {
        components : { userSidebar,userSummary,vSelect },
      data() {
        return {
          id:this.$route.params.id,
          user: {
            profile: {
              first_name: '',
              last_name: ''
            },
            investors: []
          },
          name:'',
          message:'',
          messages:[],
          investors: [],
          is_loaded: false,
          cur_slide: 0,
          cur_message_name: '',
          is_confirmed: false
        };
      },
      mounted(){
        if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
          helper.notAccessibleMsg();
          this.$router.push('/account/dashboard');
        }
        this.getInvestors();
        this.getUser();
      },
      methods: {
        getInvestors(){
          axios.get('/api/investors/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.investors = response;
                this.is_loaded = true;
              })
              .catch(error => {
                helper.showDataErrorMsg(error)
              });
        },
        getUser(){
          axios.get('/api/user/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.user = response.user;
                if(response.user.profile.questionnaire_step > 3){
                  this.is_confirmed = true;
                }else{
                  this.is_confirmed = false;
                }
              })
              .catch(error => {
                helper.showDataErrorMsg(error);
              })
        },
      },
      watch: {

      },
      filters: {

      }
    }
</script>
